import { Trans, useTranslation } from "react-i18next";
import Modal from "../Helpers/Modal";
import { useAppSelector } from "../../app/hooks";
import { selectHotel } from "../../features/hotel/hotelSlice";

interface IHowManyTravellersModalProps {
  onClick: () => void;
  show: boolean;
}

export default function HowManyTravellersModal({
  onClick,
  show,
}: IHowManyTravellersModalProps) {
  const { t } = useTranslation();
  const hotel = useAppSelector(selectHotel);
  return (
    <>
      <Modal
        onClick={onClick}
        show={show}
        title={t(
          "accommodation." + hotel.HotelCode + ".howManyTravellers.title"
        )}
      >
        <Trans
          i18nKey={
            "accommodation." + hotel.HotelCode + ".howManyTravellers.content"
          }
          components={{ ul: <ul />, li: <li />, br: <br /> }}
        />
      </Modal>
    </>
  );
}
